import React from "react";

interface IProps<T> {
  children: React.ReactNode;
  index: T;
  value: T;
  className?: string;
}

const TabPanel = <T extends string | number>(props: IProps<T>) => {
  const { children, value, index, className, ...rest } = props;

  return (
    <div
      className={className}
      role="tabpanel"
      aria-label="Tab Panel"
      hidden={value !== index}
      {...rest}
    >
      {value === index && children}
    </div>
  );
};

export default React.memo(TabPanel);
